import React, { useEffect, useState } from "react";
const RewardVideo = ({ callBack, callBackArgs }) => {
  const [displayButton, setDisplayButton] = useState(false);
  const adLoaded = () => {
    setDisplayButton(true);
    startCounter();
  };
  const [count, setCount] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  useEffect(() => {
    let interval;
    if (isRunning && count < 15) {
      interval = setInterval(() => {
        setCount((prevCount) => prevCount + 1);
      }, 1000);
    } else if (count === 15) {
      setIsRunning(false); // Stop the interval
    }
    return () => clearInterval(interval); // Cleanup interval
  }, [isRunning, count]);
  const startCounter = () => {
    setCount(0); // Reset counter
    setIsRunning(true); // Start the counter
  };
  // const adRef = useRef(null);
  // useEffect(() => {
  //   if (window.adsbygoogle && adRef.current) {
  //     try {
  //       window.adsbygoogle.push({});
  //       adLoaded();
  //     } catch (e) {
  //       console.error("AdsbyGoogle push error:", e);
  //     }
  //   }
  // }, []);
  return (
    <div
      style={{
        width: "100%",
        margin: 20,
        borderColor: "#000",
        borderWidth: 5,
        borderStyle: "solid",
      }}
    >
      <div
        style={{
          background: "#ac1b5a",
          fontWeight: "bold",
          textAlign: "left",
          color: "#fff",
          padding: 10,
        }}
      >
        External Advertisement
      </div>
      {/* 
<div 
className="ad-wrapper"
style={{
          width: "100%",
          minHeight: '70vh',
          borderWidth: 0,
          overflow: "hidden",
        }}
>
<ins
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client="ca-pub-5009916193571735"
      data-ad-slot="1957275032"
      data-ad-format="auto"
      data-full-width-responsive="true"
      ref={adRef}
    />
    </div> */}
      <iframe
        title="Reward Ads"
        src="/ad.html"
        onLoad={adLoaded}
        style={{
          width: "100%",
          height: "70vh",
          borderWidth: 0,
          overflow: "hidden",
        }}
        frameBorder={0}
        scrolling="no"
      ></iframe>
      <br />
      {displayButton ? (
        <>
          <div
            className="btn btn-success"
            onClick={() => {
              if (count >= 15) {
                callBack(callBackArgs);
              }
            }}
            style={{
              opacity: count >= 15 ? 1 : 0.8,
            }}
          >
            Continue {15 - count > 0 ? 15 - count : ""}
          </div>
          <br />
          <br />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
export default RewardVideo;
